module.exports = __webpack_public_path__ + "img/cd6b6f3.jpg";